export enum RelationshipsTranslationKey {
    COMMON_ELEMENT = "relationships.commonElement",
    EDIT_RELATIONSHIP_DETAILS = "relationships.editRelationshipDetails",
    COMMON_ELEMENT_IS_SOURCE = "relationships.commonElementIsSource",
    COMMON_ELEMENT_IS_TARGET = "relationships.commonElementIsTarget",
    FIND_COMMON_ELEMENT = "relationships.findCommonElement",
    FIND_ELEMENT = "relationships.findElement",
    INSUFFICIENT_PERMISSIONS = "relationships.insufficientPermissions",
    INSUFFICIENT_PERMISSIONS_TO_CREATE_RELATIONSHIP_BETWEEN_ELEMENTS = "relationships.insufficientPermissionsToCreateRelationshipBetweenElements",
    NAME = "relationships.name",
    NEW_RELATIONSHIP = "relationships.newRelationship",
    PICKED_ELEMENT = "relationships.pickedElement",
    PICKED_ELEMENT_IS_SOURCE = "relationships.pickedElementIsSource",
    PICKED_ELEMENT_IS_TARGET = "relationships.pickedElementIsTarget",
    RELATIONSHIPS = "relationships.relationships",
    RELATIONSHIP_DETAIL = "relationships.relationshipDetail",
    DETAILS = "relationships.details",
    RELATIONSHIP_DIRECTION = "relationships.relationshipDirection",
    RELATIONSHIP_TYPE = "relationships.relationshipType",
    SOURCE = "relationships.source",
    TARGET = "relationships.target",
    TYPE = "relationships.type",
}
